import { render, staticRenderFns } from "./comMap.vue?vue&type=template&id=a6f07ccc&scoped=true&"
import script from "./comMap.vue?vue&type=script&lang=js&"
export * from "./comMap.vue?vue&type=script&lang=js&"
import style0 from "./comMap.vue?vue&type=style&index=0&id=a6f07ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f07ccc",
  null
  
)

export default component.exports